import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Box
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import StarIcon from '@mui/icons-material/Star';
import StarOutlinedIcon from '@mui/icons-material/StarOutlined';
import EditIcon from '@mui/icons-material/Edit';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

const QueryManagementDialog = ({
  open,
  onClose,
  savedQueries = [],
  onLoadQuery,
  onRenameQuery,
  onDuplicateQuery,
  onDeleteQuery,
  onToggleFavorite
}) => {
  const columns = [
    {
      field: 'isFavorite',
      headerName: '',
      width: 60,
      sortable: false,
      renderCell: (params) => (
        <IconButton
          size='small'
          onClick={() => onToggleFavorite(params.row.id)}
        >
          {params.value ? (
            <StarIcon color='warning' />
          ) : (
            <StarOutlinedIcon />
          )}
        </IconButton>
      )
    },
    {
      field: 'name',
      headerName: 'Query Name',
      flex: 1,
      minWidth: 200
    },
    {
      field: 'modifiedAt',
      headerName: 'Last Modified',
      width: 150,
      valueFormatter: (params) => new Date(params.value).toLocaleString()
    },
    {
      field: 'fieldCount',
      headerName: 'Fields',
      width: 80,
      valueGetter: (params) => params.row.selectedFields.length
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 200,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <IconButton
            size='small'
            color='primary'
            onClick={() => { onLoadQuery(params.row); onClose(); }}
            title='Load Query'
          >
            <PlayArrowIcon />
          </IconButton>
          <IconButton
            size='small'
            onClick={() => onRenameQuery(params.row)}
            title='Rename'
          >
            <EditIcon />
          </IconButton>
          <IconButton
            size='small'
            onClick={() => onDuplicateQuery(params.row.id)}
            title='Duplicate'
          >
            <ContentCopyIcon />
          </IconButton>
          <IconButton
            size='small'
            color='error'
            onClick={() => onDeleteQuery(params.row.id)}
            title='Delete'
          >
            <DeleteIcon />
          </IconButton>
        </Box>
      )
    }
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth='lg' fullWidth>
      <DialogTitle>Manage Saved Queries</DialogTitle>
      <DialogContent>
        <Box sx={{ height: 500, width: '100%' }}>
          <DataGrid
            rows={savedQueries}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10, 25, 50]}
            disableSelectionOnClick
            initialState={{
              sorting: {
                sortModel: [{ field: 'modifiedAt', sort: 'desc' }]
              }
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant='contained'>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QueryManagementDialog;
